import ReportSubSection from '@components/ReportSubSection';
import { COMPANY_PRICE_CHART } from '@/constants/feedbackSections';
import { PCHolder } from './styled';
import loadable from '@loadable/component';
import If from '@components/If';
import ChartWrapper from '@/components/CompanyOverview/components/ChartWrapper';
import PriceChartTable from './components/PriceChartTable';

const PriceChart = loadable(() => import('@/components/PriceChart'), {
  ssr: false,
  resolveComponent: (component) => component.PriceChart,
});
interface Props {
  id?: string;
  lookup?: string;
  uniqueSymbol?: string;
}
export function SharePrice(props: Props) {
  return (
    <ReportSubSection
      trackingProps={{ subject: 'chart' }}
      body={
        <ChartWrapper
          id="overview-price-chart"
          chart={
            <PCHolder data-cy-id="company-price-chart">
              <If match={typeof props.lookup !== 'undefined'}>
                {() => <PriceChart lookup={props.lookup} />}
              </If>
            </PCHolder>
          }
          table={
            <PCHolder>
              <PriceChartTable />
            </PCHolder>
          }
          companyName={props.uniqueSymbol}
          feedbackLabel={COMPANY_PRICE_CHART}
        />
      }
    />
  );
}
